export default __webpack_public_path__ + "6a770bae2d44f98c006e865a705f3173.svg";